import { render, staticRenderFns } from "./PartDiagramPage.vue?vue&type=template&id=63cfa5ca"
import script from "./PartDiagramPage.ts?vue&type=script&lang=ts&external"
export * from "./PartDiagramPage.ts?vue&type=script&lang=ts&external"
import style0 from "./PartDiagramPage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports